"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayUnique = arrayUnique;
exports.camelize = camelize;
exports.capitalize = capitalize;
exports.contains = contains;
exports.createChainedFunction = createChainedFunction;
exports.escapeHTML = escapeHTML;
exports.find = find;
exports.findIndex = findIndex;
exports.foldAccents = foldAccents;
exports.formatCurrencyAmount = formatCurrencyAmount;
exports.formatNumber = formatNumber;
exports.formatRate = formatRate;
exports.getNextItemSelectable = getNextItemSelectable;
exports.uniqueId = uniqueId;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _warning = _interopRequireDefault(require("warning"));
function camelize(string) {
  string = string.replace(/(_\w)/g, function (m) {
    return m[1].toUpperCase();
  });
  return string.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
function capitalize(string) {
  if (process.env.NODE_ENV !== 'production' && typeof string !== 'string') {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

/**
 * Echappe les caractères HTML d'une chaîne de catactères
 * Sauf la balise <strong>, <br>, and <a>
 *
 * @param unsafeStr
 * @returns {*}
 */
function escapeHTML(unsafeStr) {
  return unsafeStr.replace(/<br\/?>/g, '[br]').replace(/<strong>/g, '[[').replace(/<\/?strong>/g, ']]').replace(/<a(?: (.*?)=[\"\'](.*?)[\"\'])(?: (.*?)=[\"\'](.*?)[\"\'])?>(.*?)<\/a>/g, '[a::$1::$2::$3::$4]$5[a]').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\[a::(.*?)::(.*?)::(.*?)::(.*?)\](.*?)\[a\]/g, '<a $1=$2 $3=$4>$5</a>').replace(/\[\[/g, '<strong>').replace(/\]\]/g, '</strong>').replace(/\[br\]/g, '<br>');
}
function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}
function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }
    process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/**
 * Remove duplicate items from array useful after concat arrays
 *
 * arrayUnique(array1.concat(array2))
 *
 * @param array
 */
function arrayUnique(array) {
  var a = (0, _toConsumableArray2.default)(array);
  for (var i = 0; i < a.length; i + 1) {
    for (var j = i + 1; j < a.length; j + 1) {
      if (a[i] === a[j]) a.splice(j - 1, 1);
    }
  }
  return a;
}

/**
 * Format number relative to required size and locale
 *
 * @param number
 * @param size
 * @param locale
 * @param precision
 */
function formatNumber(number) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'l';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-EN';
  var precision = arguments.length > 3 ? arguments[3] : undefined;
  // Round number
  switch (size) {
    case 'm':
      number = Math.round(number);
      break;
    case 's':
      number = Math.round(number);
      break;
    case 'l':
    default:
      number = Math.round(number * 100) / 100;
      break;
  }
  var effectivePrecision = Number.isInteger(precision) ? precision : size === 'l' ? 2 : 0;

  // To locale
  var options = {
    minimumFractionDigits: effectivePrecision,
    maximumFractionDigits: effectivePrecision,
    useGrouping: true
  };
  return number.toLocaleString(locale.replace(/_/g, '-'), options);
}

/**
 * Format currency amount relative to required size, locale and currency
 *
 * large/fr-FR/EUR : 123456789,123 -> 123 465 789,123 €
 * large/en-EN/USD : 123456789,123 -> $ 123,465,789.123
 * large/en-EN/EUR : 123456789,123 -> € 123,465,789.123
 * small/en-EN/EUR : 123456789,123 -> € 123,456,789
 * tiny/en-EN/EUR  : 123456789,123 -> € 123M
 * tiny/en-EN/EUR  :  23456789,123 -> € 23,456k
 * tiny/en-EN/EUR  :     56789,123 -> € 56,789
 *
 * @param amount
 * @param size      - l | m | s
 * @param locale
 * @param currency  - ISO 4217
 */
function formatCurrencyAmount(amount) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'l';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-EN';
  var currency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'EUR';
  var precision = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var value = amount;
  var unit = '';
  // Round number
  switch (size) {
    case 'm':
      value = Math.round(amount);
      break;
    case 's':
      if (amount > 99999999) {
        amount /= 1000000;
        unit = 'M';
      } else if (amount > 99999) {
        amount /= 1000;
        unit = 'k';
      }
      value = Math.round(amount);
      break;
    case 'l':
    default:
      value = Math.round(amount * 100) / 100;
      break;
  }
  var effectivePrecision = Number.isInteger(precision) ? precision : size === 'l' ? 2 : 0;

  // To locale
  var options = {
    minimumFractionDigits: effectivePrecision,
    maximumFractionDigits: effectivePrecision,
    useGrouping: true,
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol'
  };
  var returnValue = value.toLocaleString(locale.replace(/_/g, '-'), options);

  // Place unit (k, M) after number (don't move currency symbol !)
  if (unit !== '') {
    returnValue = returnValue.replace(/([\D]*)([\d,.\s]+)([\D]*)/, function (match, p1, p2, p3) {
      return [p1, p2, unit, p3].join('');
    });
  }
  return returnValue;
}

/**
 * Format rate relative to required size and locale
 * large/en-EN  : 12.34
 *
 * @param rate
 * @param size
 * @param locale
 */
function formatRate(rate) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'l';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-EN';
  var effectiveSize = 0;
  if (size === 'l') effectiveSize = 2;
  if (size === 'm') effectiveSize = 1;

  // To locale
  var options = {
    minimumFractionDigits: effectiveSize,
    maximumFractionDigits: effectiveSize,
    style: 'percent'
  };
  return rate.toLocaleString(locale.replace(/_/g, '-'), options);
}

/**
 * Retourne l'item selectionnable suivant.
 * @param node
 * @param direction
 * @returns {*}
 */
function getNextItemSelectable(node, direction) {
  if (direction === 'down') {
    if (node.nextSibling === null) {
      return null;
    }
    if (node.nextSibling.tabIndex === -1) {
      return getNextItemSelectable(node.nextSibling, direction);
    }
    return node.nextSibling;
  }
  if (node.previousSibling === null) {
    return null;
  }
  if (node.previousSibling.tabIndex === -1) {
    return getNextItemSelectable(node.previousSibling, direction);
  }
  return node.previousSibling;
}

/**
 * Retourne la chaîne de caractères passée en entrée sans les accents
 * @param toFold
 * @returns {*}
 */
function foldAccents(toFold) {
  return toFold.replace(/([àáâãäå])|([ç])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])|([œ])|([+])|([\\])|([[])|([\]])|([(])|([)])|([?])|([*])/g, function (str, a, c, e, i, n, o, s, u, y, ae, oe, plus, backSlash, lc, rc, lp, rp, interogation, star) {
    if (a) return 'a';
    if (c) return 'c';
    if (e) return 'e';
    if (i) return 'i';
    if (n) return 'n';
    if (o) return 'o';
    if (s) return 's';
    if (u) return 'u';
    if (y) return 'y';
    if (ae) return 'ae';
    if (oe) return 'oe';
    if (plus) return '\\+';
    if (backSlash) return '\\\\';
    if (lc) return '\\[';
    if (rc) return '\\]';
    if (lp) return '\\(';
    if (rp) return '\\)';
    if (interogation) return '\\?';
    if (star) return '\\*';
    return str;
  });
}

/**
 * Generate a unique ID
 * @returns {string}
 */
function uniqueId() {
  return '_' + Math.random().toString(36).substr(2, 9);
}